import { AcademicCapIcon, ClockIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import { Badge } from '@/components/ui/daisy';
import { Breakpoints } from '@/utils/Breakpoint';
import { formatLessonPlanTime } from '@/utils/lesson-plan/formatLessonPlanTime';
import ConditionalRenderer from '../ui/custom/ConditionalRenderer';

export type LessonPlansSummaryBadgesProps = {
  lessonsCount: number;
  totalMinutes: number;
};

export default function LessonPlansSummaryBadges({
  lessonsCount,
  totalMinutes,
}: LessonPlansSummaryBadgesProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.lessonPlansTab',
  });

  const isXl = useMediaQuery({ minWidth: Breakpoints.xl });
  const size = isXl ? 'md' : 'sm';

  return (
    <div className="flex items-center gap-6 flex-wrap">
      <ConditionalRenderer condition={totalMinutes}>
        <Badge color="success" size={size}>
          <ClockIcon className="size-3.5" />
          {t('totalCourseTime', { time: formatLessonPlanTime(totalMinutes) })}
        </Badge>
      </ConditionalRenderer>
      <Badge color="primary" size={size}>
        <AcademicCapIcon className="size-3.5" />
        {t('totalLessons', { count: lessonsCount })}
      </Badge>
    </div>
  );
}
